import { render, staticRenderFns } from "./NoPollsState.vue?vue&type=template&id=8338ea14&scoped=true&"
import script from "./NoPollsState.vue?vue&type=script&lang=ts&"
export * from "./NoPollsState.vue?vue&type=script&lang=ts&"
import style0 from "./NoPollsState.vue?vue&type=style&index=0&id=8338ea14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8338ea14",
  null
  
)

export default component.exports